import { EntityKeys, QueryType } from 'utils/reactQuery'

import { CreativeInstructionsDTO } from 'models/creativeInstructions'
import { useAPI } from 'utils/API'
import { useQuery } from '@tanstack/react-query'

enum Endpoints {
  GET = '/creative-instructions/{pairingId}',
}

/**
 * Calls backend-platform `GET /creative-instructions/{pairingId}`.
 * `pairingId` is the assignment id. Returns the assignment-specific instructions
 * shown as an orange banner above the guidelines list when CT/Admin opens
 * the page from the "Follow instructions" button.
 */
export function useGetCreativeInstructions(pairingId: string | undefined, enabled = true) {
  const api = useAPI<Endpoints>()

  return useQuery({
    queryKey: [EntityKeys.CREATIVE_INSTRUCTION, QueryType.GET_ONE, { pairingId: pairingId ?? null }],
    queryFn: () => api.get<CreativeInstructionsDTO>(
      Endpoints.GET,
      { pairingId: pairingId! },
      true
    ),
    enabled: enabled && !!pairingId
  })
}
